import Flickity from "flickity";
import { useEffect, useRef } from "react";
import YouTube from "react-youtube";
import DOMPurify from 'dompurify';
import { marked } from "marked";

export default function Carousel({ id, sources, types, desc, children, idx }) {
    // TODO: implement flickity support for youtube iframe
    useEffect(() => {
        initFlickity(idx);
    }, [idx]);

    const VIDEO_EXTENSIONS = [".mp4", ".mov", ".avi", ".wmv", ".flv", ".mkv", ".webm"];
    function isVideo(source) {
        for (const ex in VIDEO_EXTENSIONS) {
            if (source.endsWith(ex)) return true;
        }
        return false;
    }

    const carousel = useRef(null);

    async function initFlickity(idx) {
        if (typeof window !== 'undefined' && carousel.current) {
            new Flickity(carousel.current, {
                cellAlign: 'left',
                wrapAround: false,
                pageDots: false,
                prevNextButtons: true,
                resize: true,
                lazyLoad: (idx === 0 ? false : true),
                dragThreshold: 14
            });
        }
    }

    let i = 0;
    return (
        <>
        <div id={id} className="project">
            {children}
            <div ref={carousel} className="main-carousel ">
                {
                sources.map((source,idx) => {
                    switch (types[idx]) {
                        case "1": return (
                                <div key={id+"."+i++} className="carousel-cell">
                                    {isVideo(source) ?
                                        <video controls>
                                            <source src={"/assets/images/"+source} type={"video/"+source.split(".").at(-1)}/>
                                        </video>
                                        :
                                        <img src={"/assets/images/"+source} alt="" />
                                    }
                                </div>
                            )
                        case "2":
                            return (
                                <YouTube
                                    key={id+"."+i++}
                                    className="carousel-cell yt"
                                    videoId={source}
                                />
                            )
                        default:
                            return <></>
                        
                    }
                })
                }
            </div>
            <p className="projectdesc" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(marked.parse(desc))}}></p>
        </div>
        </>
    )
}